<template>
  <div>
    <div class="settings-top-bar location-group-form-modal" ref="optionsTopBar">
      <div class="top-bar">
       <p class="">
        <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="closeModal()">
          <i class="ti-arrow-left"></i>
          {{ $t('general.back') }}
        </a>
       </p>
       <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save" :title="$t('general.save')" @click.prevent="validate">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
          <a v-if="!isNew" class="btn btn-danger btn-icon btn btn mar-rt-10 delete" :title="$t('settingsPages.locationGroupsDelete')" @click.prevent="handleDelete('delete')">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
       </p>
      </div>
    </div>
    <div class="row mar-to-15">
      <div class="col-lg-12 col-md-12">
        <div class="card no-shadow">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <form>
            <div class="card-content">
              <p class="text-danger" v-if="errors.has('error')">
                {{ getError('error') }}
              </p>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-15">
                    <label>{{$t('settingsPages.locationGroupsName')}}</label>
                    <input type="text"
                          name="name"
                          :placeholder="$t('settingsPages.locationGroupsName')"
                          v-validate="modelValidate.name"
                          v-model="model.name"
                          class="form-control">
                    <small class="text-danger" v-if="errors.has('name')">
                      {{ getError('name') }}
                    </small>
                  </div>
                  <div class="form-group mb-15">
                    <label>{{$t('settingsPages.locationGroupsDescription')}}</label>
                    <textarea rows="5"
                          name="description"
                          :placeholder="$t('settingsPages.locationGroupsDescription')"
                          v-validate="modelValidate.description"
                          v-model="model.description"
                          class="form-control"></textarea>
                    <small class="text-danger" v-if="errors.has('description')">
                      {{ getError('description') }}
                    </small>
                  </div>

                  <!-- <div class="form-group mb-15 locations" v-if="categoryLocations.length > 1">
                    <label>{{$t('settingsPages.companyLocations')}}</label>
                    <v-select v-model="model.location_ids"
                              multiple
                              :options="categoryLocations"
                              label="name"
                              :placeholder="$t('general.none') + ' ' + $t('settingLocationGroups.write')">
                    </v-select>
                  </div> -->
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-15">
                    <label>{{$t('settingsPages.locationGroupsPhoto')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="1"
                      :file-list="imagelist"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="handleImgChnage"
                      :on-exceed="handleExceed"
                      :on-remove="handleRemove"
                      :auto-upload="false">
                      <i class="el-icon-plus"></i>
                      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                    </el-upload>
                  </div>
                  <div class="form-group mb-15 parent" v-if="parentOptions.length > 0">
                    <label>{{$t('settingLocationGroups.parentGroup')}}</label>
                    <v-select 
                      v-model="model.parent"
                      value="id"
                      label="name"
                      :options="parentOptions"
                      :placeholder="$t('general.none') + ' ' + $t('settingLocationGroups.write')">
                    </v-select>
                  </div>
                  <div class="form-group mb-15">
                    <p-switch v-model="model.active" type="success"></p-switch>
                    <label>{{$t('settingLocationGroups.active')}}</label>
                  </div>
                  <div class="form-group mb-15" v-if="editData && editData.show_slider_check">
                    <p-switch v-model="model.display_in_slider_app" type="success"></p-switch>
                    <label>{{$t('settingLocationGroups.displayInSlider')}}</label>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-15 locations" v-if="categoryLocations.length > 1">
                    <label>{{$t('settingsPages.companyLocations')}}</label>
                    <v-select v-model="model.location_ids"
                              multiple
                              :options="categoryLocations"
                              label="name"
                              :placeholder="$t('general.none') + ' ' + $t('settingLocationGroups.write')">
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import vSelect from 'vue-select'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      PSwitch,
      vSelect
    },
    props: {
      callback: {
        required: false
      },
      editData: {
        required: false,
        type: Object
      }
    },
    watch: {
      locId (value) {
        this.id = value
      },
      editData (value) {
        if (value) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          this.model = value
        }
        this.getGroupParents()
      }
    },
    computed: {
      ...mapFields(['name', 'description'])
    },
    created: function () {
      this.locations = this.$session.get('selectedCompanyData').locations_details
      this.getGroupLocations()
      this.getGroupParents()
      this.$nextTick(function () {
        this.loading = true
        this.loadingReset = true
      })
      this.$validator.localize('en', {
        en: {
          attributes: {
            name: this.$t('settingsPages.locationGroupsName'),
            description: this.$t('settingsPages.locationGroupsDescription')
          }
        }
      })
      if (this.editData) {
        if (this.editData.image) {
          this.imagelist = [{'url': this.editData.image}]
        }
        this.isNew = false
      } else {
        this.isNew = true
      }
      if (!this.isNew) {
        this.model = this.editData
      }
      this.$nextTick(function () {
        this.loading = false
        this.loadingReset = false
      })
    },
    data () {
      return {
        id: this.value || this.locId,
        isNew: true,
        model: {
          'name': '',
          'description': '',
          'active': true,
          'display_in_slider_app': false,
          'parent_id': null,
          'parent': null,
          'location_ids': []
        },
        imagelist: [],
        modelValidate: {
          name: {required: true, min: 3},
          description: {max: 255}
        },
        loading: true,
        loadingReset: true,
        parentOptions: [],
        categoryLocations: []
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveGroupLocation() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5

        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: this.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.imagelist = fileList.slice(1)
          } else {
            this.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      saveGroupLocation () {
        this.$nextTick(function () { this.loading = true })
        let data = {
          id: this.model.id,
          name: this.model.name,
          description: this.model.description,
          active: this.model.active,
          display_in_slider_app: this.model.display_in_slider_app
        }
        data.location_ids = this.parseLocationIds()
        data.parent_id = this.parseParentId()

        // check if the've removed the picture
        if (this.imagelist.length === 0) {
          data.image = ''
        }
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID
        if (
          this.imagelist &&
          this.imagelist.length &&
          this.imagelist[0].status &&
          this.imagelist[0].status === 'ready'
        ) {
          this.getBase64(this.imagelist[0].raw).then(
            (base64enc) => {
              data.image = base64enc
              this.handleImageUpload(data)
            }
          )
        } else {
          this.handleImageUpload(data)
        }
      },
      handleBack () {
        this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'))
        this.$router.push('/settings')
      },
      handleDelete (label) {
        swal({
          text: this.$t('settingsPages.locationGroupsAreYouSure', {label: label}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.isNew) {
              this.$router.push('/location-groups')
            } else {
              var data = {
                id: this.model.id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/location-groups/' + this.model.id, 'DELETE', data, (response) => {
                if (response.status === true) {
                  swal(
                    {
                      title: '',
                      text: this.$t('settingsPages.locationGroupsDelete'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }
                  )
                  this.closeModal(this.model)
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
      },
      getGroupLocations () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          columns: ['id', 'token', 'company_id', 'name', 'email', 'street', 'phone', 'active']
        }
        this.apiRequest('/locations', 'GET', data, (response) => {
          if (response.status === true) {
            this.categoryLocations = response.data
            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      getGroupParents () {
        const data = {
          id: this.model.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/location-parents', 'GET', data, (response) => {
          if (response.status === true) {
            this.parentOptions = response.data
            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      parseLocationIds () {
        if (this.model.location_ids && this.model.location_ids.length) {
          let locIds = []
          for (let idxL in this.model.location_ids) {
            locIds.push(this.model.location_ids[idxL]['token'])
          }
          return locIds
        } else {
          return null
        }
      },
      parseParentId () {
        if (this.model.parent && this.model.parent.id) {
          let parentId = null
          parentId = this.model.parent.id
          return parentId
        } else {
          return null
        }
      },
      handleImageUpload (data) {
        if (this.isNew) {
          this.apiRequest('/location-groups', 'POST', data, (response) => {
            if (response.status === true) {
              this.errors.clear()
              this.$nextTick(function () { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('settingsPages.locationGroupsAdded'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {}) // end swal
              this.$emit('on-submit', response.data)
            } else {
              this.$nextTick(function () { this.loading = false })
              this.handleErrors(response.errors)
            }
          })
        } else {
          if (data.role === 'OWNER') {
            delete data.role
          }
          this.apiRequest('/location-groups/' + this.model.id, 'PUT', data, (response) => {
            if (response.status === true) {
              this.$nextTick(function () { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('settingsPages.locationGroupsUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {}) // end swal
              this.$emit('on-submit', response.data)
            } else {
              this.$nextTick(function () { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('settingsPages.locationGroupsUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {})
              if (typeof this.callback === 'function') {
                this.callback()
              }
            }
          })
        }
      },
      closeModal (deletedGroup = null) {
        this.$emit('close-modal', deletedGroup)
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
  span.el-select__tags-text {
    color: #fff;
  }
  .el-select {
    width: 100%;
  }
  .selectMethod {
    width: 100%;
  }

  .location-group-form-modal {
    background: #F4F6FF !important;
    padding: 15px 15px 5px 15px !important;
    margin: 0 !important;
  }

  .no-shadow {
    box-shadow: none !important;
  }

  .parent div ul.dropdown-menu {
    max-height: 320px !important;
  }

  .locations div ul.dropdown-menu {
    max-height: 190px !important;
  }

  .mb-15 {
    margin-bottom: 15px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/LocationGroups/LocationGroupsForm.vue